/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PlanDTO { 
    /**
     * Unique plan identifier. Use this value when fetching, updating, duplicating, or exporting a plan.
     */
    id: number;
    /**
     * Display title of the MPO plan shown in the plan list and plan detail pages.
     */
    title: string;
    /**
     * Optimization view for this plan.
     */
    viewType: PlanDTO.ViewTypeEnum;
    /**
     * True when this plan is the user\'s or client\'s default MPO plan.
     */
    isDefault: boolean;
    /**
     * True when the plan should be shown to the current user in the plan list.
     */
    isVisible: boolean;
    /**
     * True when the plan is shared across the brand rather than owned only by one user.
     */
    isShared: boolean;
    /**
     * Reference period start date for the plan, in ISO date format.
     */
    startDate: string;
    /**
     * Reference period end date for the plan, in ISO date format.
     */
    endDate: string;
    /**
     * Optional optimization period start date for the plan, in ISO date format.
     */
    planStartDate?: string;
    /**
     * Optional optimization period end date for the plan, in ISO date format.
     */
    planEndDate?: string;
    /**
     * Reference-period label used by the plan, such as CURRENT_MONTH, LATEST_30_DAYS, or CUSTOM.
     */
    relativeDay: PlanDTO.RelativeDayEnum;
    /**
     * Conversion type ID associated with the plan.
     */
    conversionTypeId: number;
    /**
     * Number of days optimized for this plan.
     */
    optimizedForDays: number;
    /**
     * Optimization level used by MPO. Use 2 for Balanced or 5 for Maximized.
     */
    optimizationLevel: number;
    /**
     * Table breakdown dimension used by the plan, such as tactic, channel, or segment.
     */
    tableDimension: PlanDTO.TableDimensionEnum;
    /**
     * Target budget for the plan in the brand\'s configured currency.
     */
    targetBudget: number;
    /**
     * User identifier for the plan owner, when available.
     */
    userId?: string;
    /**
     * Last modification timestamp for the plan in ISO-8601 format, when available.
     */
    rModTime?: string;
    /**
     * Current access level for the authenticated user against this plan.
     */
    permission: PlanDTO.PermissionEnum;
}
export namespace PlanDTO {
    export type ViewTypeEnum = 'ROAS' | 'CPO';
    export const ViewTypeEnum = {
        Roas: 'ROAS' as ViewTypeEnum,
        Cpo: 'CPO' as ViewTypeEnum
    };
    export type RelativeDayEnum = 'AUTO_START' | 'AUTO_END' | 'ALL_TIME' | 'TODAY' | 'YESTERDAY' | 'LATEST_7_DAYS' | 'LATEST_14_DAYS' | 'LATEST_30_DAYS' | 'LATEST_52_WEEKS' | 'LATEST_90_DAYS' | 'CURRENT_MONTH' | 'PRIOR_MONTH' | 'CURRENT_QUARTER' | 'CURRENT_YEAR' | 'LAST_COMPLETE_WEEK' | 'LAST_AVAILABLE_MONTH' | 'CUSTOM' | 'PREVIOUS_PERIOD' | 'PREVIOUS_MONTH' | 'PREVIOUS_QUARTER' | 'PREVIOUS_YEAR' | 'CUSTOM_COMPARE' | 'NEXT_30_DAYS';
    export const RelativeDayEnum = {
        AutoStart: 'AUTO_START' as RelativeDayEnum,
        AutoEnd: 'AUTO_END' as RelativeDayEnum,
        AllTime: 'ALL_TIME' as RelativeDayEnum,
        Today: 'TODAY' as RelativeDayEnum,
        Yesterday: 'YESTERDAY' as RelativeDayEnum,
        Latest7Days: 'LATEST_7_DAYS' as RelativeDayEnum,
        Latest14Days: 'LATEST_14_DAYS' as RelativeDayEnum,
        Latest30Days: 'LATEST_30_DAYS' as RelativeDayEnum,
        Latest52Weeks: 'LATEST_52_WEEKS' as RelativeDayEnum,
        Latest90Days: 'LATEST_90_DAYS' as RelativeDayEnum,
        CurrentMonth: 'CURRENT_MONTH' as RelativeDayEnum,
        PriorMonth: 'PRIOR_MONTH' as RelativeDayEnum,
        CurrentQuarter: 'CURRENT_QUARTER' as RelativeDayEnum,
        CurrentYear: 'CURRENT_YEAR' as RelativeDayEnum,
        LastCompleteWeek: 'LAST_COMPLETE_WEEK' as RelativeDayEnum,
        LastAvailableMonth: 'LAST_AVAILABLE_MONTH' as RelativeDayEnum,
        Custom: 'CUSTOM' as RelativeDayEnum,
        PreviousPeriod: 'PREVIOUS_PERIOD' as RelativeDayEnum,
        PreviousMonth: 'PREVIOUS_MONTH' as RelativeDayEnum,
        PreviousQuarter: 'PREVIOUS_QUARTER' as RelativeDayEnum,
        PreviousYear: 'PREVIOUS_YEAR' as RelativeDayEnum,
        CustomCompare: 'CUSTOM_COMPARE' as RelativeDayEnum,
        Next30Days: 'NEXT_30_DAYS' as RelativeDayEnum
    };
    export type TableDimensionEnum = 'channel' | 'segment' | 'tactic';
    export const TableDimensionEnum = {
        Channel: 'channel' as TableDimensionEnum,
        Segment: 'segment' as TableDimensionEnum,
        Tactic: 'tactic' as TableDimensionEnum
    };
    export type PermissionEnum = 'OWNER' | 'READ' | 'WRITE';
    export const PermissionEnum = {
        Owner: 'OWNER' as PermissionEnum,
        Read: 'READ' as PermissionEnum,
        Write: 'WRITE' as PermissionEnum
    };
}


